export default {
  id: 'b0c2881fff',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=about><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>About</div></div></div><div class=page-content><div class="block block-strong"><p>I am a Canadian practising in California as US board-certified neurologist, after fellowship training from the Calgary Stroke Program (formerly known as Alberta Stroke Programme as in CT ASPECTS). I had several medical informatics projects in 1990-2000s prior to residency. I am familiar with client-side java / VB scripts, and server-side ASP / PHP / PERL. This app started as a simple calculator for mixing tpA during fellowship. The full package with other components finally came to friution as a byproduct of the epic year 2020! User interface was re-built using the open-source framework7 UI. Hope you find it useful. Suggestions, requests, error reporting at <a class=external href=https://strokemd.blogspot.com/ >StrokeMD.blogspot.com</a></p><p>Dion Fung MD</p></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};